import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * profile_options-Werte (und die hartkodierten Options-Listen) sind deutsche
 * Rohtexte — das Backend validiert teils gegen genau diesen Text, und einige
 * Stellen vergleichen auf ihn (z.B. Status-Ton, Pflegeempfänger-Rolle).
 * Übersetzt wird deshalb nur die ANZEIGE über die Locale-Map `option_values`
 * (Schlüssel = deutscher Rohtext). Unbekannte Texte (z.B. neu im Admin
 * angelegte Optionen) bleiben unverändert stehen.
 */
export function translateOptionLabel(map: unknown, label: string): string {
  if (map && typeof map === 'object') {
    const hit = (map as Record<string, unknown>)[label];
    if (typeof hit === 'string' && hit) return hit;
  }
  return label;
}

export function useOptionLabel(): (label: string) => string {
  const { t: tr } = useTranslation();
  // returnObjects liefert das Objekt aus dem Resource-Store — die Referenz
  // ändert sich nur mit der Sprache bzw. nach dem Nachladen der Locale. So
  // bleibt die Funktion als useMemo-Abhängigkeit stabil.
  const map = tr('option_values', { returnObjects: true }) as unknown;
  return useCallback((label: string) => translateOptionLabel(map, label), [map]);
}
